import { comparatorViewByOrder } from '../services/utils';
import { CustomViewType } from '../constants/customViews';

const getOrderedGridViews = state =>
    state.markets.customViews.filter(i => i.view_type === CustomViewType.GRID).sort(comparatorViewByOrder);

export { getOrderedGridViews };



// WEBPACK FOOTER //
// ./source/selectors/customViewsSelectors.js